import styled from 'styled-components';

import { SWReactIcons } from '@similarweb/icons';
import { colorsPalettes, setFontVariant } from '@similarweb/styles';

export const StyledTitleContainer = styled.div`
  display: flex;
  align-items: center;
  justify-content: flex-start;
  ${setFontVariant('body2', colorsPalettes.carbon[500])};
  max-width: 100%;
  gap: 4px;
  & > .text-overflow-tooltip {
    max-width: 95%;
  }
`;

export const StyledLinkIcon = styled(SWReactIcons)`
  svg path {
    fill: ${colorsPalettes.carbon[250]};
  }
`;

export const StyledLink = styled.a`
  display: flex;
`;
